import React from 'react';

export const RouteContext = React.createContext({
  pathname: '/',
  query: {},
  isMobile: false,
});
